<template>
  <div
    class="courseParent"
    v-lazy:background-image="{
      src: bg,
    }"
  >
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
    ></title-widge>

    <div class="divCourse">
      <el-collapse v-model="activeName" accordion @change="handleChange">
        <el-collapse-item
          v-for="(item, index) in datas"
          :key="index"
          :title="item.title"
          :name="index"
        >
          <div class="divContent" v-for="(v, k) in item.details" :key="k">
            <div class="divDetail">
              <div class="divTitle">{{ v.title }}</div>
              <div class="divItem">
                <div
                  class="divDetail"
                  v-for="(item1, index1) in v.details"
                  :key="index1"
                >
                  {{ item1 }}
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";

export default {
  components: {
    titleWidge,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "",
    },
    subTitleColor: {
      type: String,
      default: "",
    },

    subTitle: {
      type: String,
      default: "",
    },
    bg: {
      //背景图
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeName: 0,
    };
  },
  methods: {
    handleChange (index) {
      this.$trackEvent("学习路线", "点击", this.datas[index].title)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/courseWidge.scss";
</style>
<style lang="scss">
.parent {
  .divCourse {
    .el-collapse-item__arrow {
      position: static !important;
    }
    .el-collapse-item__arrow,
    .el-icon-arrow-right:before,
    .el-icon-caret-right,
    .el-icon-caret-right:before {
      content: "\e6e0" !important;
      background: none;
    }
    .el-collapse-item__header {
      padding: 0 37px;
      height: 70px;
      line-height: 70px;
    }
    .el-collapse-item__content {
      background: rgba(249, 249, 252, 1);
    }
  }
}
</style>
